import { styled } from '@zenbusiness/zui/styles';

export const LinkStyled = styled('a')(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.info.main
}));
